import creative_type from "dictionaries/creative_type.json";
import createOptions from "utils/createOptions";

export default createOptions(creative_type);
